import { useShallow } from 'zustand/react/shallow';
import { useStreamStore, type StreamState } from '@store/streamStore';

/**
 * useStreamData(selector) — subscribe to a specific slice of stream state.
 *
 * Each component should select only the fields it uses. This prevents
 * unnecessary re-renders when unrelated state changes elsewhere in the store.
 *
 * Examples:
 *   const { featureQuestion, featureSettings } = useStreamData(s => ({ featureQuestion: s.featureQuestion, featureSettings: s.featureSettings }));
 *   const setResultPollData = useStreamData(s => s.setResultPollData);
 *   const featureId = useStreamData(s => s.featureId);
 */
export function useStreamData<T>(selector: (state: StreamState) => T): T {
  return useStreamStore(useShallow(selector));
}
